import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

export default function useRecomposeAddress() {
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const decomposeAddress = (guid, addressData, refreshData) => {
    setLoading(true);
    axiosClient
      .put('/InventoryAddress/ReComposse', {
        guid,
        arrow: addressData.arrow,
        decreaseType: addressData.decreaseType,
        labelType: addressData.labelType,
        isMixed: addressData.isMixed,
      })
      .then(res => {
        if (res.status === 200) {
          //   const data = {
          //     ...res.data.value,
          //     children: [],
          //   };
          refreshData();
          enqueueSnackbar(res.data?.message, { variant: 'success' });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => {
        setLoading(false);
      });
  };

  return [loading, decomposeAddress];
}
